import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=18c2ae53&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c2ae53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c2ae53')) {
      api.createRecord('18c2ae53', component.options)
    } else {
      api.reload('18c2ae53', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=18c2ae53&scoped=true&", function () {
      api.rerender('18c2ae53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bVzqE6EeESP4/JS/comp/Accordion.vue"
export default component.exports